/* eslint-disable no-use-before-define */
import { format, publish } from '../../twd/twd';

const onMouseOver = (payload, _, event) => {
    publish('show_flyout', {
        el:event.target,
        showIcon: false,
        html: format.IssuerDetail(Object.assign(
            { from:'municipals/scatter-graph-offering-search' },
            payload,
        )),
    })
}

export default {
    onMouseOver,
    onClick: onMouseOver,
}